export const UNGROUPED_CLUSTER_ID = 'ungrouped';
